const getNotifications = (state) => state.getIn(['notification', 'items']);
const _toString = (notification) => {
    const type = notification.getIn(['content', 'type'])
    
    switch(type) {
        case 'ticket_transferred':
            const ticketId = String(notification.getIn(['content', 'details', 'ticket_id']));
            const to = notification.getIn(['content', 'details', 'to_name']);
            const context = ' överfördes till ';
            return 'Ärende '.concat(ticketId, context, to);
        case 'billing_change':
            return 'Faktureringsuppgifter uppdaterades'
        case 'employee_create':
            const name = notification.getIn(['content', 'details', 'name']);
            return 'Användaren ' + name + ' har skapats'
        case 'employee_delete':
            return 'En medarbetare har blivit borttagen'
        case 'customization_change':
            return 'Inställningar för ClientChat uppdaterades'
        default:
            return '';
    }
}

function getNumberUnread(notifications)
{
    let n = 0;
    for (let i = 0; i<notifications.size; i++) {
        const isRead = notifications.getIn([i, 'is_read']);
        if(!isRead){
            n++;
        }else{
            break;
        }     
    }
    
    return n;
}

export default {
    getNotifications, getNumberUnread,
    _toString
}



// WEBPACK FOOTER //
// ./src/model/Notification/selector.js